import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export interface WholesaleAccount {
  id: string;
  user_id: string;
  business_name: string;
  tier: "bronze" | "silver" | "gold";
  discount_percent: number;
  tax_exempt: boolean;
  active: boolean;
}

export const useWholesaleAccount = () => {
  const { user, loading: authLoading } = useAuth();
  const [account, setAccount] = useState<WholesaleAccount | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    if (authLoading) return;
    if (!user) {
      setAccount(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    supabase
      .from("wholesale_accounts")
      .select("id, user_id, business_name, tier, discount_percent, tax_exempt, active")
      .eq("user_id", user.id)
      .eq("active", true)
      .maybeSingle()
      .then(({ data }) => {
        if (!mounted) return;
        setAccount((data as WholesaleAccount) ?? null);
        setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [user, authLoading]);

  return { account, loading, isWholesale: !!account };
};
